var _circle, _path, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCluster = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 13,
  r: 3,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.22173 17.5C3.16685 15.6968 2.77813 13.5883 3.1218 11.5339C3.46547 9.47956 4.52027 7.60633 6.10646 6.23344M11.8207 4.00482C13.9294 3.93669 15.9967 4.59226 17.6705 5.85982C19.3442 7.12738 20.5209 8.92851 21 10.9563M20.2978 16.9806C19.3647 18.8481 17.8043 20.3384 15.8826 21.1978C13.9609 22.0571 11.7968 22.2322 9.75891 21.6933",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 2,
  width: 4,
  height: 4,
  rx: 1,
  fill: "white",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.26794,
  y: 17.7681,
  width: 4,
  height: 4,
  rx: 1,
  transform: "rotate(-30 2.26794 17.7681)",
  fill: "white",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 17.6716,
  y: 17,
  width: 4,
  height: 4,
  rx: 1,
  transform: "rotate(-45 17.6716 17)",
  fill: "white",
  stroke: "currentColor",
  strokeWidth: 1.5
})));
export default SvgCluster;